<template>
  <div>
    <Layout :pagetitle="$t('Reward Profile')">
      <Table
        :title="$t('Reward Profile')"
        :items="rewards"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="true"
        :searchable="true"
        :editable="true"
        :removable="true"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editReward"
        @onCreate="createReward"
        @onRemove="onRemove"
        @onChangePage="changePage"
      />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        }
      ],
      rewards: []
    };
  },
  mounted() {
    this.getRewardProfile();
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getRewardProfile();
    },
    onRemove(reward) {
      this.$api.destroy(`api/reward_profile/${reward.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('Reward was excluded with success')
        });
        this.getRewardProfile();
      });
    },
    getRewardProfile() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/reward_profile/', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.rewards = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createReward() {
      this.$router.push({
        name: 'rewardProfileCreate'
      });
    },
    editReward(reward) {
      this.$router.push({
        name: 'rewardProfileUpdate',
        params: {
          id: reward.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getRewardProfile();
    }
  }
};
</script>

<style></style>
